export default __webpack_public_path__ + "static/media/2_3.9c3d566f.jpg";